export const connect = () => ({ type: 'ws.connect' } as const)
export type WsConnectAction = ReturnType<typeof connect>

export const connectSuccess = () => ({ type: 'ws.connect-success' } as const)
export type WsConnectSuccessAction = ReturnType<typeof connectSuccess>

export const connectFailure = (err: any) =>
  ({ type: 'ws.connect-failure', payload: err } as const)
export type WsConnectFailureAction = ReturnType<typeof connectFailure>

export const adjustServerTimeDelay = () =>
  ({ type: 'ws.adjust-server-time' } as const)
export type AdjustServerTimeDelayAction = ReturnType<
  typeof adjustServerTimeDelay
>

export const adjustServerTimeDelaySuccess = (delayMs: number) =>
  ({ type: 'ws.adjust-server-time-success', payload: { delayMs } } as const)
export type AdjustServerTimeDelaySuccessAction = ReturnType<
  typeof adjustServerTimeDelaySuccess
>

export const logError = (error: any) =>
  ({ type: 'ws.log-error', payload: error } as const)
export type LogErrorAction = ReturnType<typeof logError>

export const forceReload = () => ({ type: 'ws.force-reload' } as const)
export type ForceReloadAction = ReturnType<typeof forceReload>

export const cancelForceReload = () =>
  ({ type: 'ws.cancel-force-reload' } as const)
export type CancelForceReloadAction = ReturnType<typeof cancelForceReload>

export const logServerMetadata = () =>
  ({ type: 'ws.log-server-metadata' } as const)
export type LogServerMetadataAction = ReturnType<typeof logServerMetadata>

export const initTime = (time: Date) =>
  ({ type: 'ws.init-time', payload: time } as const)
export type InitTimeAction = ReturnType<typeof initTime>

export type WsAction =
  | WsConnectAction
  | WsConnectSuccessAction
  | WsConnectFailureAction
  | AdjustServerTimeDelayAction
  | AdjustServerTimeDelaySuccessAction
  | LogErrorAction
  | ForceReloadAction
  | CancelForceReloadAction
  | LogServerMetadataAction
  | InitTimeAction
